import { useCreateOrUpdatePhotographyInBibliography } from "@/api/related-fields";
import { LinkableType } from "@/components/LinksManagement";
import { FormLayoutElement } from "@/config/forms/general";
import { PhotographyInBibliography } from "@/lib/types";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import LinksDrawerLayout from "./LinksDrawerLayout";

const PhotographyInBibliographyDrawer = ({
  fields,
  data,
  queryId,
  type,
  open,
  onOpenChange,
}: {
  fields: FormLayoutElement[] | undefined;
  data: PhotographyInBibliography;
  queryId: string;
  type: LinkableType;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}) => {
  const schema = z.object({
    photographiesDansBibliographieDescriptionReproduitPage: z
      .string()
      .optional(),
    photographiesDansBibliographieDescriptionCitePage: z.string().optional(),
    photographiesDansBibliographieDescriptionPhotographe: z.string().optional(),
    photographiesDansBibliographieDescriptionReproductionCouleur: z
      .boolean()
      .optional(),
    photographiesDansBibliographieDescriptionNonPagine: z.boolean().optional(),
    bibliography: z.object({
      bibliographieDescriptionNumeroBibliographie: z.string().optional(),
      bibliographieDescriptionResumeLong: z.string().optional(),
    }),
  });

  const { mutate: createOrUpdatePhotographyInBibliography } =
    useCreateOrUpdatePhotographyInBibliography(queryId, type);

  const form = useForm<z.infer<typeof schema>>({
    resolver: zodResolver(schema),
    defaultValues: {
      bibliography: data.bibliography,
      photographiesDansBibliographieDescriptionReproduitPage:
        data.photographiesDansBibliographieDescriptionReproduitPage,
      photographiesDansBibliographieDescriptionCitePage:
        data.photographiesDansBibliographieDescriptionCitePage,
      photographiesDansBibliographieDescriptionPhotographe:
        data.photographiesDansBibliographieDescriptionPhotographe,
      photographiesDansBibliographieDescriptionReproductionCouleur:
        data.photographiesDansBibliographieDescriptionReproductionCouleur,
      photographiesDansBibliographieDescriptionNonPagine:
        data.photographiesDansBibliographieDescriptionNonPagine,
    },
  });

  const onSubmit = (formData: z.infer<typeof schema>) => {
    createOrUpdatePhotographyInBibliography({
      id: data.id,
      photographyId: data.photography.id,
      bibliographyId: data.bibliography.id,
      ...formData,
    });
  };
  const isFromBibliography = type === "bibliography";
  const previewConfig = isFromBibliography
    ? {
        attachments: data.photography?.attachments ?? [],
        type: "photography" as const,
        alt: data.photography?.photosDescriptionNumeroEnregistrement,
      }
    : {
        attachments: data.bibliography?.attachments ?? [],
        type: "bibliography" as const,
        alt:
          data.bibliography?.bibliographieDescriptionNumeroBibliographie ??
          data.bibliography?.bibliographieDescriptionTitre,
      };

  return (
    <LinksDrawerLayout
      form={form}
      fields={fields ?? []}
      recordId={data.id}
      onSubmit={onSubmit}
      previewImage={previewConfig}
      open={open}
      onOpenChange={onOpenChange}
    />
  );
};

export default PhotographyInBibliographyDrawer;
